"use client"

import { Trans } from "@lingui/react/macro"
import { cn } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"

export type GachaPaymentAsset = "USDG" | "ETH"

export const GachaPaymentSelector = reatomComponent(
  ({
    value,
    onChange,
    disabled = false,
    tokenSymbol = "USDG",
  }: {
    value: GachaPaymentAsset
    onChange: (value: GachaPaymentAsset) => void
    disabled?: boolean
    tokenSymbol?: string
  }) => (
    <div className="flex items-center justify-between gap-3">
      <span className="text-sm text-foreground/60">
        <Trans>Pay with</Trans>
      </span>
      <div className="flex rounded-md border border-foreground/10 p-1">
        {(["USDG", "ETH"] satisfies GachaPaymentAsset[]).map((asset) => (
          <button
            key={asset}
            type="button"
            aria-pressed={value === asset}
            disabled={disabled}
            className={cn(
              "rounded px-4 py-1.5 text-sm transition-colors disabled:opacity-40",
              value === asset
                ? "bg-brand/10 text-brand"
                : "text-foreground/60 hover:bg-foreground/5",
            )}
            onClick={() => onChange(asset)}
          >
            {asset === "ETH" ? "ETH" : tokenSymbol}
          </button>
        ))}
      </div>
    </div>
  ),
  "GachaPaymentSelector",
)
